<template>
  <div class="invalid-feedback">
    <small>{{ errorMessage }}</small>
  </div>
</template>

<script setup lang="ts">
import { ErrorObject } from "@vuelidate/core";
import { computed, ref } from "vue";

const { errors = [], error = "" } = defineProps<{
  errors?: ErrorObject[];
  error?: string;
}>();
const errorMessage = computed(() => {
  return error || errors.find((e: any) => e)?.$message || error;
});
</script>
